export default __webpack_public_path__ + "static/media/BannerPrice.195cf967.png";